/** @format */

import { ITreeNode, TreeNode } from '@designable/core'
import { transformToSchema, transformToTreeNode } from '@designable/formily-transformer'
import { MonacoInput, setNpmCDNRegistry } from '@designable/react-settings-form'
import React from 'react'

const monitorCdn = process.env.MONITOR_CDN
if (monitorCdn) {
  setNpmCDNRegistry(monitorCdn)
}

export interface ISchemaEditorWidgetProps {
  tree: TreeNode
  onChange?: (tree: ITreeNode) => void
}

export const SchemaEditorWidget: React.FC<ISchemaEditorWidgetProps> = props => {
  return (
    <MonacoInput
      {...props}
      value={JSON.stringify(transformToSchema(props.tree), null, 2)}
      onChange={value => {
        props.onChange?.(transformToTreeNode(JSON.parse(value)))
      }}
      language="json"
    />
  )
}
